import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IMAGE_URLS } from 'src/app/core/constants/image-source';
import { DownloadType } from '../downloads/downloads.component';


@Component({
  standalone: true,
  selector: 'base-document-button',
  templateUrl: './document-button.component.html',
  styleUrls: ['./document-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule]
})
export class DocumentButtonComponent {

  IMAGE_URLS = IMAGE_URLS;

  label = input<string>('');
  href = input<string>('');
  type = input<string>('');

  DownloadType = DownloadType;

}

